// extracted by mini-css-extract-plugin
module.exports = {"container":"container--uF0WD","attempt":"attempt--2c0KA"};